"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasDateFilterForDateDataset = exports.isDateFilterIrrelevant = exports.isDateFilterIgnored = exports.isAttributeFilterIgnored = exports.filterArrayToFilterContextItems = exports.stripDateDatasets = exports.dashboardFilterToFilterContextItem = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_model_1 = require("@gooddata/sdk-model");
/**
 * Converts a {@link IDashboardFilter} to a {@link FilterContextItem}.
 * @param filter - filter to convert
 */
function dashboardFilterToFilterContextItem(filter) {
    if (sdk_model_1.isAttributeFilter(filter)) {
        var attributeElements = sdk_model_1.filterAttributeElements(filter);
        if (!sdk_model_1.isAttributeElementsByRef(attributeElements)) {
            // For attributes with a lot of elements, this transformation can be very expensive.
            // Let's enforce user to provide element uris by himself.
            throw new sdk_backend_spi_1.NotSupported("Attribute filter with text values is not supported. Please provide element uris instead.");
        }
        return {
            attributeFilter: {
                negativeSelection: sdk_model_1.isNegativeAttributeFilter(filter),
                displayForm: sdk_model_1.filterObjRef(filter),
                attributeElements: attributeElements,
            },
        };
    }
    else if (sdk_model_1.isAbsoluteDateFilter(filter)) {
        return {
            dateFilter: {
                type: "absolute",
                granularity: "GDC.time.date",
                from: filter.absoluteDateFilter.from,
                to: filter.absoluteDateFilter.to,
                dataSet: filter.absoluteDateFilter.dataSet,
            },
        };
    }
    else if (sdk_model_1.isRelativeDateFilter(filter)) {
        if (!sdk_backend_spi_1.isDateFilterGranularity(filter.relativeDateFilter.granularity)) {
            // Only a subset of granularity can be stored in the filter context.
            throw new sdk_backend_spi_1.NotSupported("Unsupported date filter granularity! Please provide valid date filter granularity. (Check DateFilterGranularity type)");
        }
        return {
            dateFilter: {
                type: "relative",
                granularity: filter.relativeDateFilter.granularity,
                from: filter.relativeDateFilter.from,
                to: filter.relativeDateFilter.to,
                dataSet: filter.relativeDateFilter.dataSet,
            },
        };
    }
    throw new sdk_backend_spi_1.NotSupported("Unsupported filter type! Please provide valid dashboard filter.");
}
exports.dashboardFilterToFilterContextItem = dashboardFilterToFilterContextItem;
/**
 * Remove information about the date dataset from Date filters. Attribute filters are returned unchanged.
 * @param filter - filter to strip date dataset from
 */
function stripDateDatasets(filter) {
    if (!sdk_backend_spi_1.isDashboardDateFilter(filter)) {
        return filter;
    }
    var _a = filter.dateFilter, _ = _a.dataSet, rest = tslib_1.__rest(_a, ["dataSet"]);
    return {
        dateFilter: rest,
    };
}
exports.stripDateDatasets = stripDateDatasets;
function filterArrayToFilterContextItems(filters) {
    return filters.map(function (filter) {
        if (sdk_backend_spi_1.isDashboardDateFilter(filter) || sdk_backend_spi_1.isDashboardAttributeFilter(filter)) {
            return filter;
        }
        else {
            return dashboardFilterToFilterContextItem(filter);
        }
    });
}
exports.filterArrayToFilterContextItems = filterArrayToFilterContextItems;
function isAttributeFilterIgnored(widget, displayForm) {
    return widget.ignoreDashboardFilters.some(function (filter) {
        return sdk_backend_spi_1.isDashboardAttributeFilterReference(filter) && sdk_model_1.areObjRefsEqual(filter.displayForm, displayForm);
    });
}
exports.isAttributeFilterIgnored = isAttributeFilterIgnored;
function isDateFilterIgnored(widget, displayForm) {
    return widget.ignoreDashboardFilters.some(function (filter) { return sdk_backend_spi_1.isDashboardDateFilterReference(filter) && sdk_model_1.areObjRefsEqual(filter.dataSet, displayForm); });
}
exports.isDateFilterIgnored = isDateFilterIgnored;
function isDateFilterIrrelevant(widget) {
    var dateDataSetRef = widget.dateDataSet;
    // backward compatibility for old kpis
    var ignoredOldWay = isDateFilterIgnored(widget, dateDataSetRef);
    // now dataSetRef is cleaned
    var checkboxEnabled = !!dateDataSetRef;
    return !checkboxEnabled || ignoredOldWay;
}
exports.isDateFilterIrrelevant = isDateFilterIrrelevant;
function hasDateFilterForDateDataset(filters, dateDataset) {
    return filters.some(function (filter) {
        if (!sdk_model_1.isDateFilter(filter)) {
            return false;
        }
        return sdk_model_1.areObjRefsEqual(sdk_model_1.filterObjRef(filter), dateDataset);
    });
}
exports.hasDateFilterForDateDataset = hasDateFilterForDateDataset;
//# sourceMappingURL=filters.js.map